import MuiTable from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import { usePagination, useTable } from "react-table";
import MuiDialog from "@mui/material/Dialog";
import {
  Button,
  DialogActions,
  IconButton,
  TableContainer,
  Typography,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { useState } from "react";
import NfcForm from "./NfcForm";
import { useTheme } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import toast from "react-hot-toast";

const styles = {
  hideColumn: {
    display: 'none'
  }
};

export default function NfcListData({ columns, data }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(null);
  const [filteredData, setFilteredData] = useState();
  const navigate = useNavigate();
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [tableData, setTableData] = useState(data);
  
  // columns = columns.filter(column => column.accessor !== 'ix');

  const {
    getTableProps,
    headerGroups,
    page,
    prepareRow,
    gotoPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data: tableData,
      initialState: { pageSize: 5 },
    },
    usePagination
  );

  const handleChangePage = (event, newPage) => {
    gotoPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(event.target.value);
    gotoPage(0);
  };
  const getColumns = (cell) => {
    if (cell.column.id === "actions") {
      return (
        <>
          <Button onClick={() => handleEditSubmit(cell)} variant="contained">
            Edit
          </Button>
          <Button
            className="delete-button"
            onClick={() => handleDelete(cell.row.original.id)}
            variant="contained"
            sx={{ backgroundColor: '#d32f2f', '&:hover': { backgroundColor: '#d32f2f' } }}
          >
            Delete
          </Button>
        </>
      );
    } else {
      return cell.value;
    }
  };
  const handleEditSubmit = (cell) => {
    const userId = cell?.row?.original?.id;
    setOpen(cell);
    const filteredData = data.find((data) => data.id === userId);
    setFilteredData(filteredData);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleDelete = async (id) => {
    setDeleteId(id);
    setDeleteConfirmOpen(true);
  };

  const confirmDelete = async () => {
    try {
      const response = await axios.delete(`/api/nfc/${deleteId}`);
      if (response.status === 200) {
        setDeleteConfirmOpen(false);
        setDeleteId(null);
        setTableData(prevData => prevData.filter(item => item.id !== deleteId));
        toast.success('NFC deleted successfully');
      }
    } catch (error) {
      console.error('Error deleting NFC:', error);
      toast.error('Failed to delete NFC. Please try again.');
    }
  };

  return (
    <>
      <TableContainer>
        <MuiTable {...getTableProps()}>
          <TableHead>
            {headerGroups.map((headerGroup) => (
              <TableRow {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <TableCell 
                    {...column.getHeaderProps()}
                    sx={column.id === "ix" ? styles.hideColumn : {}}
                  >
                    {column.render("Header")}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableHead>
          {tableData.length !== 0 ? (
            <TableBody>
              {page.map((row, i) => {
                prepareRow(row);
                return (
                  <TableRow {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <TableCell
                          {...cell.getCellProps()}
                          className={
                            cell.column.id === "actions"
                              ? "user-action-button-container"
                              : cell.column.id === "ix"
                              ? "hide-column"
                              : ""
                          }
                          sx={cell.column.id === "ix" ? styles.hideColumn : {}}
                        >
                          {getColumns(cell)}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          ) : (
            <TableBody>
              <div className="no-record-wrapper">
                <Typography
                  className="no-record-class "
                  component="h3"
                  variant="h6"
                  color="inherit"
                  noWrap
                  sx={{ flexGrow: 1 }}
                >
                  No Record
                </Typography>
              </div>
            </TableBody>
          )}
        </MuiTable>
        {tableData.length !== 0 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={tableData.length}
            rowsPerPage={pageSize}
            page={pageIndex}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </TableContainer>

      <MuiDialog
        fullScreen={fullScreen}
        open={open == null ? false : true}
        maxWidth={"md"}
        fullWidth={true}
        onClose={handleClose}
        className="delete-confirmation  rozcomapp-custom-modal"
        aria-labelledby="responsive-dialog-title"
      >
        <DialogActions>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          ></IconButton>
          <NfcForm filteredData={filteredData} setOpen={setOpen} />
        </DialogActions>
        <Button autoFocus onClick={handleClose}>
          cancel
        </Button>
      </MuiDialog>

      <Dialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            textAlign: 'center',
            minWidth: '400px',
            padding: '20px',
          },
        }}
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
          {"Confirm Delete"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText 
            id="alert-dialog-description"
            style={{ textAlign: 'center', marginBottom: '20px' }}
          >
            Are you sure you want to delete this NFC? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center', padding: '20px' }}>
          <Button 
            onClick={() => setDeleteConfirmOpen(false)}
            variant="outlined"
            sx={{ minWidth: '100px', mr: 1 }}
          >
            Cancel
          </Button>
          <Button 
            onClick={confirmDelete} 
            autoFocus
            variant="contained"
            sx={{ 
              minWidth: '100px',
              ml: 1,
              backgroundColor: '#d32f2f', 
              color: 'white', 
              '&:hover': { 
                backgroundColor: '#b71c1c' 
              } 
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
